module.exports = "data:image/svg+xml;base64,PHN2ZyB0PSIxNjM5NDQ5NDU2OTY1IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjM2OTciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTg5NiAyNTZIMTI4VjEyOGg3Njh2MTI4eiBtMCAxOTJIMTI4djEyOGg3NjhWNDQ4eiBtMCAzMjBIMTI4djEyOGg3NjhWNzY4eiIgcC1pZD0iMzY5OCIgZmlsbD0iI2NjY2NjYyI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sort-type-one.svg
// module id = 9QNv
// module chunks = 0